import $ from 'jquery';
const rcProps = window.rcProps || {};
const hearts = rcProps.hearts || {};
// rcProps may be absent; fall back to the limit the server enforces rather than silently passing
const maxFavoritesCount = typeof hearts.maxCount === 'number' ? hearts.maxCount : 1999;
const mensHeart = hearts.mensHeart === 'true';

window.heartBrand = heartBrand;
window.heartProductUpdated = heartProductUpdated;
window.showFavLimitPopupModal = showFavLimitPopupModal;
window.heartBrandUpdated = heartBrandUpdated;
window.clearOldFavItems = clearOldFavItems;
window.heartProduct = heartProduct;
window.submitHeart = submitHeart;
window.reloadHearts = reloadHearts;

function heartBrand(elem, bcode){
    heartProduct(elem, bcode, "brand");
}

function heartProductUpdated(element, productCode, callback){
    let container = $(element);
    let activeHeartClass = window.rcProps && window.rcProps.favoriteActiveClass || 'favorite-button--active';
    let productName = container.data('product-name');
    if (container.hasClass(activeHeartClass)){
        submitHeart('product', productCode, 'remove', undefined, undefined, undefined, undefined, function() {
            container.removeClass(activeHeartClass);
        } );
    } else {
        let productSize = $("#heart_total_count").data('totalFavoriteCount');
        if (rcProps.isGuest || productSize > maxFavoritesCount) {
            showFavLimitPopupModal(isGuest, productCode);
            return;
        }
        submitHeart('product', productCode, 'add', undefined, undefined, undefined, undefined, function() {
            container.addClass(activeHeartClass);
        });
    }
    if (typeof callback === 'function') {
        callback(element, productCode);
    }
}

function showFavLimitPopupModal(isGuest, productCode) {
    $.modal({
        triggerOpen: true,
        url: rcProps.hearts.favMaxPopupHref,
        type: "small",
        onComplete: function(){
            if (isGuest) {
                $('#guestLimitPop, #fav-create-link').attr('href', "/r/SignIn.jsp?favcode=" + productCode + "&page=" + encodeURIComponent(window.location.pathname + window.location.search));
            }
        }
    });
}

function heartBrandUpdated(elem, bcode, callback){
    if (hearts.isGuestButHeartingDisabled === 'true') {
        $('#favorite-designer-modal').find('a').attr('href', '/r/SignIn.jsp?favbrand=' + encodeURIComponent(bcode) + '&d=' + '<%=p.department%>'
            + '&page=' + '<%=CommonFromJSP.getCurrentPageURLEncoded(request, true)%>');
        $.modal({
            triggerOpen: true,
            open: "favorite-designer-modal"
        });
    } else {
        let container = $(elem);

        const $favoriteNotify = container.next('.js-favorite-notify');
        const unfavoritedMessageNotif = container.data('unfavorite-notification');
        const favoritedMessageNotif = container.data('favorite-notification');
        const unfavoriteMessage = container.data('unfavorite-message');
        const favoriteMessage = container.data('favorite-message');
        const messageContainer = '.u-screen-reader';

        let activeHeartClass = window.rcProps && window.rcProps.favoriteActiveClass || 'favorite-button--active';
        if (container.hasClass(activeHeartClass) || container.data('is-active')) {
            submitHeart('brand', bcode, 'remove', undefined, undefined, undefined, function() {
                container.removeClass(activeHeartClass);
                $favoriteNotify.text(unfavoritedMessageNotif);
                container.find(messageContainer).text(favoriteMessage);
            }, callback);
        } else {
            if (!container.data('use-active-attr')) {
                container.addClass(activeHeartClass);
            }
            submitHeart('brand', bcode, 'add', undefined, undefined, undefined, function() {
                $favoriteNotify.text(favoritedMessageNotif);
                container.find(messageContainer).text(unfavoriteMessage);
            }, callback);
        }
    }
}

function clearOldFavItems() {
    $.ajax({
        type: 'GET',
        url: '/r/ajaxHeartProduct.jsp?action_T=clearolditems',
        success: function (data) {
            location.reload();
        }
    });
}

function heartProduct(elem, pcode,size,view){
    let bn = elem;
    let brand = false;
    let plpHeartClass = "plp_main_img_heart";
    let plpHeartActiveClass = "active";
    if(mensHeart){
        plpHeartClass = "plp_main_img_heartm";
    }

    if(typeof arguments[2] !== "undefined" && arguments[2] === "brand" ) {
        brand = true;
    }

    if(typeof elem.id === "undefined" || (elem.id !== "heart_active_"+pcode && $('div.active', elem).length == 0)){
        if(brand)	submitHeart("brand", pcode, "add");
        else submitHeart("product", pcode, "add");
        for(let j=0; j< bn.childNodes.length; j++){
            let bn2 = bn.childNodes[j];
            switch(bn2.nodeType){
                case 3:
                    //text Node
                    break;
                case 1:
                    //Element node (anchor, div)
                    if(bn2.nodeName.toLowerCase() === "div" || bn2.className.toLowerCase() === plpHeartClass ){
                        bn2.className += " "+plpHeartActiveClass;
                    }
                    break;
                default:
                //break;
            }
        }
        elem.id = "heart_active_"+pcode;
        if(typeof arguments[3] === "undefined"){
            if(document.getElementById("plp_quickview_wrap_"+pcode)!=null){
                var pd = document.getElementById("plp_quickview_wrap_"+pcode);
                heartingUnhearting(pd,pcode,"add",plpHeartActiveClass);
            }
        }else{
            if(arguments[3]  === "qv"){
                if(document.getElementById("plp_prod_wrap_"+pcode)!=null){
                    let pd = document.getElementById("plp_prod_wrap_"+pcode);
                    heartingUnhearting(pd,pcode,"add",plpHeartActiveClass);
                }
            }
        }
    }else{
        if(brand) {
            submitHeart("brand", pcode, "remove");
        } else {
            if(typeof arguments[2] !== "undefined" && arguments[2] !== ""){
                submitHeart("product", pcode, "remove",size);
            }else{
                submitHeart("product", pcode, "remove");
            }
        }
        for(let j=0; j< bn.childNodes.length; j++){
            let bn2 = bn.childNodes[j];
            switch(bn2.nodeType){
                case 3:
                    //text Node
                    break;
                case 1:
                    //Element node (anchor, div)
                    if(bn2.nodeName.toLowerCase() === "div" || bn2.className.toLowerCase() === plpHeartClass ){
                        if(bn2.className.toLowerCase().indexOf(plpHeartActiveClass) !== -1 )	bn2.className = plpHeartClass;
                    }
                    break;
                default:
                //break;
            }
        }
        elem.id = "";
        if(typeof arguments[3] === "undefined"){
            if(document.getElementById("plp_quickview_wrap_"+pcode)!=null){
                let pd = document.getElementById("plp_quickview_wrap_"+pcode);
                heartingUnhearting(pd,pcode,"remove",plpHeartClass);
            }
        }else{
            if(arguments[3]  === "qv"){
                if(document.getElementById("plp_prod_wrap_"+pcode)!=null){
                    let pd = document.getElementById("plp_prod_wrap_"+pcode);
                    heartingUnhearting(pd,pcode,"remove",plpHeartClass);
                }
            }
        }
    }

}
function submitHeart(paramtype, paramvalue){
    if (typeof paramtype === "undefined" || typeof paramvalue === "undefined" || typeof arguments[2] ==="undefined") {
        return;
    }
    let psize = "";
    // optional argument
    if(typeof arguments[3] !=="undefined" ) {
        psize = arguments[3];
    }
    let sectionUrl = "";
    if (typeof arguments[4] !=="undefined" ) {
        sectionUrl = arguments[4];
    }
    let callback = null;
    if (typeof arguments[6] !== 'undefined'){
        callback = arguments[6];
    }
    let onSuccess = arguments[7];
    let dataToSend="";
    let department = $('#header-jsp').data('department');
    if(paramtype === "product")	{
        dataToSend += "&pcode="+encodeURIComponent(paramvalue);
    } else if(paramtype === "brand")	{
        dataToSend += "&bcode="+encodeURIComponent(paramvalue);
    }
    dataToSend += "&action_T="+encodeURIComponent(arguments[2]);
    if (mensHeart) {
        dataToSend += "&mensBrand="+encodeURIComponent("true");
    } else {
        dataToSend += "&mensBrand="+encodeURIComponent("false");
    }
    if (psize !=="") {
        dataToSend += "&psize=" + encodeURIComponent(psize);
    }
    if (sectionUrl !=="") {
        dataToSend += "&sectionURL="+encodeURIComponent(sectionUrl);
    }
    if (department) {
        dataToSend += "&d=" + encodeURIComponent(department);
    }
    $.ajax({
        type: 'POST',
        url: '/r/ajaxHeartProduct.jsp',
        data: dataToSend,
        success: function(response){
            if(paramtype === "product") {
                if (response.success) {
                    updateHeartCount(response.count);
                }
                if (response.action === 'add') {
                    if(typeof insertCordialUpdateHeartItem === 'function'){
                        insertCordialUpdateHeartItem('add', paramvalue);
                    }
                    if(typeof iPinYouHeartItem === 'function'){
                        iPinYouHeartItem(paramvalue);
                    }
                    if(typeof insertRTBHouseHeartItem === 'function') {
                        insertRTBHouseHeartItem(paramvalue);
                    }
                } else if (response.action === 'remove') {
                    if(typeof insertCordialUpdateHeartItem === 'function'){
                        insertCordialUpdateHeartItem('remove', paramvalue);
                    }
                }
                if(typeof taboolaWishListAction === 'function'){
                    taboolaWishListAction(response.action,paramvalue);
                }
                if(typeof cfyWishListAction === 'function'){
                    cfyWishListAction(response.action, response.code, response.price);
                }

                if(typeof brazeAddToFavorites === 'function' && response.success === true) {
                    brazeAddToFavorites(response.action,
                        response.code,
                        response.name,
                        response.size,
                        response.imageUrl,
                        response.productUrl,
                        response.price,
                        response.currency,
                        response.department,
                        response.color,
                        response.brandName,
                        response.category,
                        response.cat1
                    );
                }

            } else if(paramtype === "brand"){
                if(typeof gaUpdateHeartBrand === 'function'){
                    gaUpdateHeartBrand(response.action,paramvalue);
                }

                if(typeof brazeBrandFavorites === 'function') {
                    brazeBrandFavorites(response.action, response.brandName, response.brandId);
                }
            }
            if (typeof callback === 'function'){
                callback();
            }
            if(response.success) {
                if(typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        }
    });
}

function reloadHearts(){
    $.ajax({
        type: 'POST',
        url: '/r/ajax/ReloadHeartItems.jsp',
        dataType: 'json',
        success: function(response){
            for (let i=0; i < response.length; i++) {
                $(".plp_prod_a_" + response[i]).attr("id","heart_active_" + response[i]);
                $("#plp_prod_wrap_"+response[i]+" .plp_main_img_heart").attr("class", "plp_main_img_heart active");
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/heart.js